export const locale = {
  lang: 'en-CA',
  data: {
    PRODUCT_UPSELL_PANEL: {
      TITLE: 'Suggestions (upsell)',
      HINT: 'Products suggested to the customer in the online store when this product is added to the cart. Never blocking.',
      SEARCH: 'Search the product catalog',
      TYPE_TO_SEARCH: 'Type at least 2 characters to search',
      LEFT_LIST_LABEL: 'Drag & drop or use the + button to add products',
      RIGHT_LIST_LABEL: 'Suggestions (in display order)',
      NO_RESULTS: 'No results',
      NO_SUGGESTIONS: 'No suggestion for this product.',
      SHARED_WARNING:
        'These suggestions are shared with {{count}} other product(s) — changes will apply to all of them.',
      ADVANCED: 'Customer panel options',
      TITLE_HINT:
        'Title shown to the customer on the suggestions panel. Leave empty to use the default title.',
      TITLE_FR: 'Title (FR)',
      TITLE_EN: 'Title (EN)',
      TITLE_DEFAULT_FR: 'Vous aimeriez aussi…?',
      TITLE_DEFAULT_EN: 'You might also like…?',
      IS_ACTIVE: 'Active in the store',
      CHECKOUT_TRIGGER: 'Also show at checkout',
      CHECKOUT_TRIGGER_NONE: 'No',
      CHECKOUT_TRIGGER_TRIGGER_PRODUCT: 'If the cart contains this product',
      CHECKOUT_TRIGGER_ALCOHOLIC_PRODUCT:
        'If the cart contains an alcoholic product',
      CHECKOUT_TRIGGER_ALWAYS: 'Always',
      CHECKOUT_TRIGGER_HINT:
        'The panel opens once when the customer reaches the checkout page, on top of the product add.',
    },
  },
};
